<template>
    <button ref="dropDownContainer" @click="toggleDropDown" class="relative border-r border-l border-white flex items-center gap-2 px-2" :class="extraclasswrapper">
        <!-- <IconGlobe /> -->
        <div class="uppercase text-white" :class="extraclasslabel">{{ $i18n.locale }}</div>
        <ul v-show="dropDown === true"
            class="absolute top-10 left-0 z-50 bg-gray-100 mt-1 flex flex-col item-center justify-center shadow max-lg:right-0 max-lg:left-auto">
            <li>
                <button @click="switchLanguage('tk')"  
                    class="px-5 flex gap-2 w-full font-medium whitespace-nowrap text-start text-black text-sm py-3 hover:bg-gray-200 ease-linear transition-all duration-150"
                    :class="extraclassbtn">
                    TK
                </button>
            </li>
            <li>
                <button @click="switchLanguage('ru')" 
                    class="px-5 flex gap-2 w-full font-medium whitespace-nowrap text-start text-black text-sm py-3 hover:bg-gray-200 ease-linear transition-all duration-150"
                    :class="extraclassbtn">
                    RU
                </button>
            </li>
            <!-- <li>
                <button @click="switchLanguage('en')"
                    class="px-5 flex gap-2 w-full font-medium text-start text-black text-sm py-3 hover:bg-gray-200 ease-linear transition-all duration-150">
                    EN
                </button>
            </li> -->
        </ul>
    </button>
</template>

<script>
// import IconGlobe from './icons/IconGlobe.vue'
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { i18n } from '@/i18n'


export default {
    name: "LanguageSwitcher",
    components: {
        // IconGlobe
    },
    props: {
        extraclasslabel: {
            type: String,
            default: ''
        },
        extraclassbtn: {
            type: String,
            default: ''
        },
        extraclasswrapper: {
            type: String,
            default: ''
        }
    },
    setup() {
        const dropDownContainer = ref()
        const dropDown = ref(false)
        onClickOutside(dropDownContainer, () => dropDown.value = false)
        const toggleDropDown = () => {
            dropDown.value = !dropDown.value
        }
        return {
            dropDownContainer,
            dropDown,
            toggleDropDown
        }
    },
    methods: {
        switchLanguage(language) {
            i18n.global.locale.value = language
            localStorage.setItem('lang', language)
            window.location.reload()
        }
    }
}


</script>